
import { Award, BookOpen, Heart, Target, Briefcase, UserCheck, Code, TestTube } from "lucide-react";

// Type definitions for better type safety
interface Qualification {
  title: string;
  description: string;
}

interface ProfessionalExperience extends Qualification {
  icon: typeof Award | typeof Briefcase | typeof UserCheck | typeof Target | typeof Code;
}

interface CoreCompetency extends Qualification {
  icon: typeof Award | typeof Heart | typeof Target | typeof BookOpen | typeof TestTube;
}

// Data for the formal qualifications
const formalQualifications: Qualification[] = [
  { 
    title: "Biologie-Studium mit Schwerpunkt Molekularbiologie", 
    description: "Vom Labor in die Wirtschaft: Mein Biologie-Studium mit Schwerpunkt Molekularbiologie führte mich fast bis zum Diplom und lehrte mich präzises, analytisches Denken. Die bewusste Entscheidung für den Wechsel in die Wirtschaft erlaubt mir heute, komplexe Herausforderungen mit wissenschaftlicher Genauigkeit und unternehmerischem Weitblick zu lösen." 
  },
  { 
    title: "Geprüfter Fachwirt für Finanzberatung (IHK)", 
    description: "Den Kern meiner fachlichen Grundlage bildet der Abschluss als **Geprüfter Fachwirt für Finanzberatung (IHK)** – eingestuft auf DQR-Niveau 6 (entspricht Bachelor-Niveau). Die Qualifikation verbindet fundiertes Finanzwissen mit Kompetenzen in Unternehmensführung, Personalverantwortung und strategischer Beratung." 
  },
  { 
    title: "Zertifizierter ETF-Consultant", 
    description: "Spezialisierung auf Exchange Traded Funds und passive Anlagestrategien" 
  },
  { 
    title: "Ausbildung zum Supervisor", 
    description: "Fortbildung im Operation Management und Coaching von Mitarbeitern" 
  },
];

// Data for the professional experience - Reordered for better flow and impact
const professionalExperience: ProfessionalExperience[] = [
  { 
    title: "Teamleiter Mondial Kundenservice GmbH", 
    description: "Strategische Führung Teamleitung Personenversicherungen (zwei Teams) bei der Mondial Kundenservice GmbH (Allianz Partners Deutschland GmbH), mit flacher Hierarchie, direkt der Geschäftsführung unterstellt. Zusätzliche Verantwortung als Datenschutzkoordinator.",
    icon: UserCheck
  },
  { 
    title: "Supervisor bei Sellbytel", 
    description: "Ausbildung zum Supervisor (entspricht Teamleiter) mit Verantwortung für Prozessoptimierung und Teamführung innerhalb der BBDO Gruppe",
    icon: Briefcase
  },
  { 
    title: "Abteilungsleitung Investmentfonds bei BSC GmbH", 
    description: "Strategische Leitung des Investmentfondsbereichs mit Verantwortung für Prozesse und Teamführung. (Firma erloschen)",
    icon: Target
  },
  { 
    title: "Finanz- und Versicherungsmakler", 
    description: "Beratung im gehobenen Kundensegment mit Fokus auf ganzheitliche Lösungen", 
    icon: Briefcase
  },
  { 
    title: "Honorarberatung", 
    description: "Entwicklung und Implementierung von unabhängigen Beratungskonzepten auf Honorarbasis", 
    icon: Award
  },
  { 
    title: "Blockchain & Distributed Systems", 
    description: "Praktische Blockchain-Erfahrung durch Aufbau und Betrieb mehrerer Fullnodes (Bitcoin, Chia, Theta, Helium), IoT-Blockchain-Integration und Entwicklung von Konzepten für die praktische Anwendung dezentraler Technologien.",
    icon: Code
  },
  { 
    title: "Privatinvestor", 
    description: "Seit frühester Jugend aktiv in Finanzanlagen investiert – mit 18 Jahren begonnen",
    icon: Award
  },
];

// Core competencies for the bottom section
const coreCompetencies: CoreCompetency[] = [
  { 
    title: "Neurowissenschaftlich fundiert", 
    description: "Coaching-Ansatz basiert auf aktuellen Erkenntnissen der Neurowissenschaft zur optimalen Entscheidungsfindung", 
    icon: TestTube
  },
  { 
    title: "Emotionale Intelligenz", 
    description: "Berücksichtigung emotionaler und kognitiver Faktoren bei finanziellen Entscheidungsprozessen", 
    icon: Heart
  },
  { 
    title: "Evidenzbasierte Methodik", 
    description: "Anwendung wissenschaftlich belegter Techniken zur Überwindung kognitiver Verzerrungen", 
    icon: Target
  },
  { 
    title: "Kontinuierliche Expertise", 
    description: "Lebenslanges Lernen und regelmäßige Weiterbildung in Finanzpsychologie und Verhaltensökonomie", 
    icon: Award
  },
];

// Export all data as a single object for easy importing
export const qualificationData = {
  formalQualifications,
  professionalExperience,
  coreCompetencies
};
